<script>
  export let time;
  export let locale = 'vi';

  import { formatDateLabel } from '$lib/utils/datetime';
</script>

<div class="flex items-center justify-center my-3">
  <span class="px-3 py-[2px] text-xs rounded-full bg-gray-200 text-gray-600">
    {formatDateLabel(time, locale)}
  </span>
</div>
